/**
 * NL类库
 *
 * @module nllib
 */

/**
 * list转换成tree
 *
 * @class nllib/src/tree-helper/list_to_tree
 * @static
 *
 * @param {object} pParameter
 *
 * @param {array} pParameter.list 一维数组
 * @param {string} pParameter.property_name_for_id id的属性名称
 * @param {string} pParameter.property_name_for_parent_id parent_id的属性名称
 * @param {string} pParameter.property_name_for_children children的属性名称
 * @param {string} pParameter.check_is_root 检查当前结点是否为根结点
 * <div>方法签名：function ({node}) {}</div>
 * <div>默认方法：function ({node}) {return !node.parent_id;}</div>
 *
 * @return {array} 一维数组，通过property_name_for_children包含树状数据
 *
 * @demo src/tree-helper/list_to_tree/1.1.0/demo/list_to_tree.demo.js
 */

// const extend = require(`extend`);
// const Q = require(`q`);
const _ = require(`underscore`);
// const moment = require(`moment`);

const __check_is_root = function ({node}) {
  return !node.parent_id;
};

const list_to_tree = function (pParameter) {
  if (!pParameter) pParameter = {};
  const list = pParameter.list;
  const property_name_for_id = pParameter.property_name_for_id || `id`;
  const property_name_for_parent_id = pParameter.property_name_for_parent_id || `parent_id`;
  const property_name_for_children = pParameter.property_name_for_children || `children`;
  const check_is_root = _.isFunction(pParameter.check_is_root) ? pParameter.check_is_root : __check_is_root;

  if (!_.isArray(list)) {
    const msg = `list_to_tree parameter error, code=001`;
    console.error(msg);
    console.trace();
    return [];
  }

  _.each(list, function (entity) {
    const id = entity[property_name_for_id];

    const children = _.chain(list)
        .filter(function (m) {
          const parent_id = m[property_name_for_parent_id];
          return id === parent_id;
        })
        .value()
    ;
    if (children.length <= 0) {
      return
    };

    entity[property_name_for_children] = children;
  });

  const tree = _.chain(list)
      .filter(function (m) {
        return check_is_root({
          node: m,
        }) && m[property_name_for_children];
      })
      .value()
  ;

  return tree;
};

module.exports = list_to_tree;
